import { CategoryData } from './residentialCategories'

export const signsAccentsCategories: CategoryData[] = [
  {
    route: '/6m8/address-plaques-and-house-numbers.html',
    label: 'Address Plaques & House Numbers',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/address-plaques-and-house-numbers.html',
    total: 172,
    products: [
      {
        title: 'HouseMark Small Roundtangle White w/ Brass Address Plaque',
        sku: 'H1-SRWH',
        price: '$199.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2Fgaines%2FH1-SRWH.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/H1-SRWH--housemark-small-roundtangle-white-w-brass-address-plaque.html',
      },
      {
        title: 'QualArc Ridgestone DIY Oval Address Plaque System',
        sku: 'RIG-4911',
        price: '$41.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FRidgeStone-Oval-Sandstone.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/RIG-4911--qualarc-ridgestone-diy-oval-address-plaque-system.html',
      },
      {
        title: 'QualArc Ridgestone DIY Rectangle Address Plaque System',
        sku: 'RIG-4912',
        price: '$41.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FRidgeStone-Rectangle-Slate.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/RIG-4912--qualarc-ridgestone-diy-rectangle-address-plaque-system.html',
      },
      {
        title: 'QualArc Ridgestone DIY Serpentine Address Plaque System',
        sku: 'RIG-4913-SS',
        price: '$41.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FRidgeStone-Serpentine-Sandstone.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/RIG-4913-SS--qualarc-ridgestone-diy-serpentine-address-plaque-system.html',
      },
      {
        title: 'QualArc Edgewood Large DIY Lighted Address Plaque LTL-1301',
        sku: 'LTL-1301',
        price: '$149.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FLTL-1301-PW-PN.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/LTL-1301--qualarc-edgewood-large-diy-lighted-address-plaque-ltl-1301.html',
      },
      {
        title: 'QualArc Edgewood Vertical DIY Lighted Address Plaque LTV-1303',
        sku: 'LTV-1303',
        price: '$167.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FLTV-1303-AC.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/LTV-1303--qualarc-edgewood-vertical-diy-lighted-address-plaque-ltv-1303.html',
      },
      {
        title:
          'QualArc Edgewood Classic DIY Lighted Address Plaque LTP-1304 -LED',
        sku: 'LTP-1304-LED',
        price: '$79.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2Fquarlarc%2Fedgewood_LTL_black.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/LTP-1304-LED--qualarc-edgewood-classic-diy-lighted-address-plaque-ltp-1304-led.html',
      },
      {
        title: 'QualArc Rockport Oval Solid Granite Address Plaque ROC-4701',
        sku: 'ROC-4701',
        price: '$148.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FClaridon-Oval-Slate-Black.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/ROC-4701--qualarc-rockport-oval-solid-granite-address-plaque-roc-4701.html',
      },
      {
        title: 'QualArc Executive Rectangle Solid Granite Address Plaque',
        sku: 'EXE-4702',
        price: '$148.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FClaridon-Rectangle-Autum-Leaf.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/EXE-4702--qualarc-executive-rectangle-solid-granite-address-plaque.html',
      },
      {
        title: 'QualArc Ridgecrest Arch Solid Granite Address Plaque RID-4703',
        sku: 'RID-4703',
        price: '$141.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2FAddress%20Plaques%2FClaridon-Arched-White.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/RID-4703--qualarc-ridgecrest-arch-solid-granite-address-plaque-rid-4703.html',
      },
    ],
  },
  {
    route: '/6m8/street-signs-traffic-signs.html',
    label: 'Street Signs & Traffic Signs',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/street-signs-traffic-signs.html',
    total: 69,
    products: [
      {
        title: 'R1-2 Yield Sign-MUTCD Regulatory Sign',
        sku: 'R1-2 Yield Sign',
        price: '$50.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2Fyeild.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/R1-2%20Yield%20Sign--Prismatic-Hi-Intensity-R1-2-Yield-Sign%20.html',
      },
      {
        title: 'R1-1 Stop Sign-MUTCD Regulatory Sign',
        sku: 'R1-1 Stop Sign',
        price: '$58.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR1-1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/R1-1%20Stop%20Sign--r1-1-stop-sign-mutcd-regulatory-sign.html',
      },
      {
        title: '24 Inch MUTCD R4-7A Keep Right With Arrow Sign',
        sku: 'Keep Right w/Arrow Sign',
        price: '$33.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2Fr4-7akeeprightarrow.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Keep%20Right%20w/Arrow%20Sign--24-inch-MUTCD-R4-7A-Keep-Right-with-Arrow-Sign.html',
      },
      {
        title: '18 inch MUTCD R4-7 Keep Right Sign',
        sku: '18 inch Keep Right Sign',
        price: '$46.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR4-7Keeprightnose.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/18%20inch%20Keep%20Right%20Sign--18-inch-MUTCD-R4-7-Keep-Right-Sign.html',
      },
      {
        title: '24 Inch MUTCD R3-4 No U Turn Sign',
        sku: 'No U Turn Sign',
        price: '$50.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR3-4NOuturn.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/No%20U%20Turn%20Sign--24-inch-MUTCD-R3-4-No-U-Turn-Sign.html',
      },
      {
        title: 'R5-1 Do Not Enter Sign-MUTCD Regulatory Sign',
        sku: 'R5-1 Do Not Enter',
        price: '$42.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR5-1donotenterredcircle.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/R5-1%20Do%20Not%20Enter--r5-1-do-not-enter-sign-mutcd-regulatory-sign.html',
      },
      {
        title: '18 Inch by 24 inch MUTCD R2-1 Speed Limit Sign',
        sku: '18 inch Speed Limit Sign',
        price: '$46.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR2-1speedlimit.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/18%20inch%20Speed%20Limit%20Sign--18-inch-MUTCD-R2-1-Speed-Limit-Sign.html',
      },
      {
        title: '24 Inch MUTCD R3-2 No Left Turn Sign',
        sku: 'No Left Turn Sign',
        price: '$70.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FR3-2noleftturn.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/No%20Left%20Turn%20Sign--24-inch-MUTCD-R3-2-No-Left-Turn-Sign.html',
      },
      {
        title: '24 Inch MUTCD W1-5R Winding Road Right Warning Sign',
        sku: 'Winding Road Right Warning Sign',
        price: '$50.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FWarning%2FW1-5RWindingroad.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Winding%20Road%20Right%20Warning%20Sign--24-inch-MUTCD-W1-5R-Winding-Road-Right-Warning-Sign.html',
      },
      {
        title: '24 Inch MUTCD W11-1-Bicycle Warning Sign',
        sku: 'Bicycle Warning Sign',
        price: '$50.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSignage%2FSignage%2FWarning%2FW11-1bike.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Bicycle%20Warning%20Sign--24-inch-MUTCD-W11-1-Bicycle-Warning-Sign.html',
      },
    ],
  },
  {
    route: '/6m8/decorative-signage.html',
    label: 'Decorative Signage',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/decorative-signage.html',
    total: 156,
    products: [
      {
        title: 'Premiere Charleston Decorative Stop Sign System',
        sku: 'Charleston Stop Sign',
        price: '$497.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fpremier%2Fpremier%2Fardleystop.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Charleston%20Stop%20Sign--Premier-Series-Decorative-Victorian%20Charleston-Stop-Sign.html',
      },
      {
        title: 'Special Lite Products Vista Series Speed Limit Sign',
        sku: 'Special Lite Products Vista Series Speed Limit Sign',
        price: '$352.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpecial%20Lite%20Street%2F2019%20Images%20Forsite%20fight%2FVista-Series-Street-Name-Sign-Pole-7.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Special%20Lite%20Products%20Vista%20Series%20Speed%20Limit%20Sign--Special-Lite-Products-Vista-Series-One-Way-Sign-R4-7A.html',
      },
      {
        title: 'Imperial Post Number 2 Speed limit',
        sku: '#2 Post/Speed Limit',
        price: '$480.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fimperial%2Fimperial%2FImperialPost2speedlimit.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/%232%20Post/Speed%20Limit--imperial-post-number-2-speed-limit.html',
      },
      {
        title: 'Imperial Warning Sign with Finial 2 base 2 and Frame',
        sku: 'Warning Sign',
        price: '$553.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fimperial%2Fimperial%2FWarningsignwbase2.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Warning%20Sign--imperial-warning-sign-with-finial-2-base-2-and-frame.html',
      },
      {
        title:
          'Imperial Mailbox Systems DOT Century Breakaway 18x24 inch Traffic Sign',
        sku: 'Traffic Sign',
        price: '$360.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fimperial%2Fimperial%2Fkeepright.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Traffic%20Sign--Imperial-Mailbox-Systems-DOT-Century-Breakaway-18x24-inch-Traffic-Sign.html',
      },
      {
        title: 'Executive Charleston Dual Hanging Scroll Street Sign',
        sku: '4',
        price: '$904.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fpremier%2Fpremier%2FSpencerStreet_Sign.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4%27%27%20Charleston%20Dual%20Hanging%20Scroll--Executive-Series-4%27%27-Charleston-Dual-Hanging-Scroll-Street-Sign.html',
      },
      {
        title: 'Executive Charleston Decorative Stop Sign',
        sku: '4',
        price: '$600.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fpremier%2Fpremier%2F4charlesstopsign%20(2).jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4%27%27%20Charleston%20Stop%20Sign--executive-charleston-decorative-stop-sign.html',
      },
      {
        title: 'Executive Charleston Single Pole Mount Street Sign',
        sku: '4',
        price: '$707.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FFairview%20Farms%2FFairview%20Farms%2Ffairviewsinglesign.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4%27%27%20Charleston%20Single%20Pole--Executive-Series-4%27%27-Charleston-Single-Pole-Mount-Street-Sign.html',
      },
      {
        title: 'Premiere Avenel Decorative Stop Sign System',
        sku: 'Decorative Avenel Stop Sign',
        price: '$498.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fpremier%2Fpremier%2Favenelstop.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Decorative%20Avenel%20Stop%20Sign--Premier-Series-Decorative-Avenel-Stop-Sign.html',
      },
      {
        title: 'Premier Series Stop Sign With Finial',
        sku: 'Decorative Stop Sign with finial',
        price: '$358.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FNew%20Morris%20Street%2FNew%20Morris%20Street%2Fmorrisfarmstop.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/Decorative%20Stop%20Sign%20with%20finial--premier-series-stop-sign-with-finial.html',
      },
    ],
  },
  {
    route: '/6m8/lighting.html',
    label: 'Lighting',
    sourceUrl: 'https://www.midatlanticmailboxes.com/6m8/lighting.html',
    total: 60,
    products: [
      {
        title: '8041 1/2" Lap Siding Light Block',
        sku: '8041-LB',
        price: '$25.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FOur%20light-Satelite%20blocks%2F8041-LB%20Light%20Mounting%20Block.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/8041-LB--8041-1-2-lap-siding-light-block.html',
      },
      {
        title: '8051 SB-LB 5/8" Lap 4" Siding Light Block',
        sku: '8051 SB-LB',
        price: '$33.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FOur%20light-Satelite%20blocks%2FSB-LB%208051%20Solid%20Mounting%20Block.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/8051%20SB-LB--8051-sb-lb-5-8-lap-4-siding-light-block.html',
      },
      {
        title: 'Mayne Signature Lamp Post White',
        sku: '5835-W',
        price: '$229.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20Address%20signs%20new%2F5835-W-Signature%20Lamp%20Post%20with%20Mount%20White-PS.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5835-W--Mayne-Signature-Lamp-Post-White.html',
      },
      {
        title: 'Mayne Signature Lamp Post Black',
        sku: '5835-B',
        price: '$229.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2FMayne%20mailbox%20post%20new%2FMayne%20Lamp%20Posts%20new%2F5835BK-Signature%20Lamp%20Post%20w-Mount%20Black-Product-673995583515.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5835-B--mayne-signature-lamp-post-black.html',
      },
      {
        title: '16" Post Mount Poly-carbonate Acorn Globe',
        sku: '2810-PC1016-CL',
        price: '$189.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2F2810-PC1016_LG.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/2810-PC1016-CL--16-post-mount-poly-carbonate-acorn-globe.html',
      },
      {
        title: '16" Poly-carbonate Globe with 6" base',
        sku: 'PC1016CL',
        price: '$127.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fpc1016CL.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/PC1016CL--16-poly-carbonate-globe-with-6-base.html',
      },
      {
        title: 'Poly-carbonate Globe with 8" base',
        sku: 'PC1023CL',
        price: '$145.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fpc1023CL.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/PC1023CL--poly-carbonate-globe-with-8-base.html',
      },
      {
        title: 'Poly-carbonate Globe with 8" base',
        sku: 'PC1026CL',
        price: '$162.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fpc1026.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/PC1026CL--poly-carbonate-globe-with-8-base.html',
      },
      {
        title: 'Poly-carbonate Globe with 8" base',
        sku: 'PC2020CL',
        price: '$150.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fpc1020CL.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/PC2020CL--poly-carbonate-globe-with-8-base.html',
      },
      {
        title: '26" Prismatic Clear Globe with 8" base Type III',
        sku: 'AC1026CL-Type III',
        price: '$368.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fpc1026_typeIII.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/AC1026CL-Type%20III--26-prismatic-clear-globe-with-8-base-type-iii.html',
      },
    ],
  },
  {
    route: '/6m8/home-garden-accents.html',
    label: 'Home & Garden Accents',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/home-garden-accents.html',
    total: 258,
    products: [
      {
        title: 'Whitehall Products Large Country Bell 00604',
        sku: '00604',
        price: '$51.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2FBL00601B.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/00604--whitehall-products-large-country-bell-00604.html',
      },
      {
        title: 'Whitehall Products Medium Country Bell 00614',
        sku: '00614',
        price: '$31.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2FBL00610.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/00614--whitehall-products-medium-country-bell-00614.html',
      },
      {
        title: 'Whitehall Products Victorian Hose Holder',
        sku: '00953 - Blk',
        price: '$50.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2FHH00958.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/00953%20-%20Blk--Whitehall-Products-Victorian-Hose-Holder.html',
      },
      {
        title: 'Mayne Fairfield 28.5" Tall Patio Planter 5829-Black',
        sku: '5829-B',
        price: '$129.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2F5829B-Fairfield%20Tall-Black-PS1-300dpi.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5829-B--mayne-fairfield-28-5-tall-patio-planter-5829-black.html',
      },
      {
        title: 'Mayne Fairfield 28.5" Tall Patio Planter 5829-White',
        sku: '5829-W',
        price: '$129.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2F5829W-Fairfield%20Tall-White-PS1-300dpi.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5829-W--mayne-fairfield-28-5-tall-patio-planter-5829-white.html',
      },
      {
        title: 'Mayne Cambridge Tall Patio Planter 4834W',
        sku: '4834-W',
        price: '$155.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2Fnewmayneplanterimages2015%2F4834W-Cambridge%20Tall%20White-ps.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4834-W--mayne-cambridge-tall-patio-planter-4834w.html',
      },
      {
        title: 'Mayne Cambridge Tall Patio Planter 4834B',
        sku: '4834-B',
        price: '$155.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2Fnewmayneplanterimages2015%2F4834B-Cambridge%20Tall%20Black-ps.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4834-B--mayne-cambridge-tall-patio-planter-4834b.html',
      },
      {
        title: 'Mayne Nantucket Tall Patio Planter 4833W',
        sku: '4833-W',
        price: '$139.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2F4833W-Nantucket%20Tall%20White-ps.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4833-W--mayne-nantucket-tall-patio-planter-4833w.html',
      },
      {
        title: 'Mayne Nantucket Tall Patio Planter 4833B',
        sku: '4833-B',
        price: '$139.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2F4833B-Nantucket%20Tall%20Black-ps.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/4833-B--mayne-nantucket-tall-patio-planter-4833b.html',
      },
      {
        title: 'Mayne Fairfield 20" x 20" Square Patio Planter White 5825-W',
        sku: '5825-W',
        price: '$169.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20planters%2F5825-W-Fairfield%20Patio%20Planter%2020x20%20White-ps1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5825-W--mayne-fairfield-20-x-20-square-patio-planter-white-5825-w.html',
      },
    ],
  },
  {
    route: '/6m8/message-boards.html',
    label: 'Message Boards',
    sourceUrl: 'https://www.midatlanticmailboxes.com/6m8/message-boards.html',
    total: 6,
    products: [
      {
        title: 'Single Message Board with Header and Cork Board',
        sku: 'UV330-1',
        price: '$1,575.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FUV330-1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/UV330-1--single-message-board-with-header-and-cork-board.html',
      },
      {
        title: 'Single Message Board with Header and Letter Board',
        sku: 'UV1140-H-1',
        price: '$1,575.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FUV1140H-1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/UV1140-H-1--single-message-board-with-header-and-letter-board.html',
      },
      {
        title: 'Double Message Board with Header and Cork/Letter Combo Board',
        sku: 'MB4836WH-B-MBH408TSB2BLK',
        price: '$2,944.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FMessage-Board-Lake-Saint-Clair-2-2.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MB4836WH-B-MBH408TSB2BLK--double-message-board-with-header-and-cork-letter-combo-board.html',
      },
      {
        title: 'Double Message Board with Cork/Letter Combo Board',
        sku: 'MB4836WO-B-MBH408TSB2BLK',
        price: '$2,520.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FUV303-2.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MB4836WO-B-MBH408TSB2BLK--double-message-board-with-cork-letter-combo-board.html',
      },
      {
        title: 'Single Message Board with Cork Board',
        sku: 'UV301-1',
        price: '$1,425.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FUV301-1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/UV301-1--single-message-board-with-cork-board.html',
      },
      {
        title: 'Single Message Board with Letter Board',
        sku: 'UV1131I-1',
        price: '$1,425.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FMessage%20Boards%202023%2FUV1131I-1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/UV1131I-1--single-message-board-with-letter-board.html',
      },
    ],
  },
]
